import { render, staticRenderFns } from "./OutpatientReviewModifiers.vue?vue&type=template&id=d6cb6b12&scoped=true&"
import script from "./OutpatientReviewModifiers.vue?vue&type=script&lang=js&"
export * from "./OutpatientReviewModifiers.vue?vue&type=script&lang=js&"
import style0 from "./OutpatientReviewModifiers.vue?vue&type=style&index=0&id=d6cb6b12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6cb6b12",
  null
  
)

export default component.exports